import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../services/api';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import SkillsSection from '../components/home/SkillsSection';
import FeaturedProjects from '../components/home/FeaturedProjects';
import StatsSection from '../components/home/StatsSection';
import ExperienceTimeline from '../components/home/ExperienceTimeline';
import LoadingSpinner from '../components/common/LoadingSpinner';

const Home = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getProfile()
      .then(res => { if (res.success) setProfile(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <Helmet>
        <title>{profile?.fullName || 'Deepak Chauhan'} | Software Developer Portfolio</title>
        <meta name="description" content={profile?.shortBio || 'Software Developer Portfolio'} />
        <meta property="og:title" content={`${profile?.fullName} | Portfolio`} />
        <meta property="og:description" content={profile?.shortBio} />
      </Helmet>
      <HeroSection profile={profile} />
      <AboutSection profile={profile} />
      <StatsSection />
      <SkillsSection />
      <FeaturedProjects />
      <ExperienceTimeline />
    </>
  );
};

export default Home;
